export const DATABASE = {
  NAME: 'aladin',
  VERSION: 1, // increment the version in case of evolving local database
}

export const COLLECTIONS = {
  CALCULATOR: 'calculator',
}

export async function dbRequest() {
  return new Promise((resolve, reject) => {
    const req: IDBOpenDBRequest = window.indexedDB.open(DATABASE.NAME, DATABASE.VERSION)
    req.onsuccess = (event) => {
      // @ts-expect-error revoir le typage d'IndexedDB
      resolve(event.target?.result)
    }

    req.onerror = (event) => {
      // @ts-expect-error revoir le typage d'IndexedDB
      reject(event.target?.error)
    }

    req.onupgradeneeded = (event) => {
      // @ts-expect-error revoir le typage d'IndexedDB
      const db = event.target?.result
      db.createObjectStore('calculator', { keyPath: 'id' })
    }
  })
}

export function useIndexedDB(collectionName) {
  const getEntry = async (entryID) => {
    const request = await dbRequest()
    // @ts-expect-error revoir le typage d'IndexedDB
    const collection = request.transaction([collectionName]).objectStore(collectionName)
    return new Promise((resolve, reject) => {
      const req = collection.get(entryID)

      req.onsuccess = () => {
        resolve(req.result)
      }

      req.onerror = (event) => {
        reject(event.target?.error)
      }
    })
  }

  const setEntry = async (entryObject) => {
    const request = await dbRequest()
    // @ts-expect-error revoir le typage d'IndexedDB
    const collection = request.transaction([collectionName], 'readwrite').objectStore(collectionName)
    collection.add(JSON.parse(JSON.stringify(entryObject)))
  }

  const putEntry = async (entryObject) => {
    const request = await dbRequest()

    // @ts-expect-error revoir le typage d'IndexedDB
    const collection = request.transaction([collectionName], 'readwrite').objectStore(collectionName)
    collection.put(JSON.parse(JSON.stringify(entryObject)))
  }

  return { getEntry, setEntry, putEntry }
}
